import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <h3>Home Page</h3>
        </div>
    );
}

export default Dashboard;